<template>
  <div class="airEnergyWrap" v-loading="$store.state.user.loadingState">
    <AnalysisHead @getActiveTime="getActiveTime" />
    <div class="analysis">
      <div class="leftBox ashComWrap">
        <div class="comTitle">
          <h4>用能分析</h4>
        </div>
        <div
          class="comContentBox"
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div class="box1 secondAshComWrap">
            <div class="comTitle">
              <h4>总览</h4>
            </div>
            <div class="comContentBox">
              <div class="topBox" v-for="(v, i) in overviewData" :key="i">
                <AnalysisOverview :overviewData="v" />
              </div>
              <!-- <div class="bottomBox">
                <PublicEcharts
                  :id="'overviewCharts'"
                  :chartsData="overviewChartData"
                  :type="'scaleCharts'"
                />
              </div> -->
            </div>
          </div>
          <div class="box2 secondAshComWrap">
            <div class="comTitle">
              <h4>中央空调用电分析</h4>
            </div>
            <div class="comContentBox">
              <PublicEcharts
                :id="'box2'"
                :chartsData="orderData"
                :type="'ringChart'"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="rightBox ashComWrap">
        <div class="comTitle">
          <h4>时长统计</h4>
        </div>
        <div
          class="comContentBox"
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div class="box3 secondAshComWrap">
            <div class="comTitle">
              <h4>中央空调末端运行时长top5</h4>
            </div>
            <div class="comContentBox">
              <PublicEcharts
                :id="'electricityDay'"
                :chartsData="centralAir"
                :type="'horizontalBar'"
              />
            </div>
          </div>
          <!-- <div class="box4 secondAshComWrap">
            <div class="comTitle">
              <h4>分体空调运行时长top5</h4>
            </div>
            <div class="comContentBox">
              <PublicEcharts
                :id="'electricityNight'"
                :chartsData="splitAir"
                :type="'horizontalBar'"
              />
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="chartsListBox">
      <div class="leftCom">
        <ChartsCard
          :title="'24小时用能分析'"
          :id="'hours'"
          :tabsList="tabsList"
          :active="hoursActive"
          :chartsData="hoursCharts"
          @getActiveItem="getActiveItem"
        />
      </div>
      <div class="rightCom">
        <ChartsCard
          :title="rightTitle"
          :id="'electricity'"
          :tabsList="tabsList"
          :active="electricity"
          :chartsData="electricityCharts"
          @getActiveItem="getActiveItem"
        />
      </div>
    </div>
    <AnalysisTable
      :title="'用电详情表'"
      :tabHead="tabHead"
      :tableData="tableData"
      :excelTitle="excelTitle"
      :showDownload="judgeAuthority('zixitong:kongtiao:airEnergy:export')"
    />
  </div>
</template>

<script>
import api from "@/api";
import {
  dateFtt,
  judgeAuthority,
  matchingECMode,
  handleNumDecimal,
} from "@/assets/js/utils";
import AnalysisHead from "@/components/fenxizujian/AnalysisHead";
import AnalysisTwoChart from "@/components/fenxizujian/AnalysisTwoChart";
import AnalysisTable from "@/components/fenxizujian/AnalysisTable";
import AnalysisOverview from "@/components/fenxizujian/AnalysisOverview";
import PublicEcharts from "@/components/PublicEcharts";
import ChartsCard from "@/components/fenxizujian/ChartsCard.vue";
export default {
  components: {
    AnalysisHead,
    AnalysisTwoChart,
    AnalysisTable,
    AnalysisOverview,
    PublicEcharts,
    ChartsCard,
  },
  data() {
    return {
      activeTime: {},
      hoursActive: "ec",
      electricity: "ec",
      tabsList: [
        { name: "用电", value: "ec" },
        { name: "用气", value: "gc" },
      ],
      rightTitle: "",
      excelTitle: "",
      tabHead: [],
      tableData: [],
      hoursCharts: {
        unit: "",
        type: "bar",
        xData: [],
        dataArr: [],
      },
      electricityCharts: {
        unit: "",
        type: "bar",
        xData: [],
        dataArr: [],
      },
      // overviewChartData: { dataArr: [] },
      overviewData: [],
      centralAir: {
        unit: "小时",
        xData: [],
        yData: [],
      },
      splitAir: {
        unit: "小时",
        xData: [],
        yData: [],
      },
      orderData: {
        unit: "kw·h",
        dataArr: [],
      },
      pubParams: {},
    };
  },
  methods: {
    judgeAuthority,
    getActiveItem(data) {
      if (data.type == "24小时用能分析") {
        this.hoursActive = data.active;
        this.getFourEC();
      } else {
        this.electricity = data.active;
        this.getECData();
      }
    },
    getTableHeade() {
      this.tabHead = [
        { label: "时间", prop: "time" },
        {
          label: `燃气/${this.activeTime.type == "MONTH" ? "m³" : "万m³"}`,
          prop: "gasAll",
        },
        {
          label: `总用电/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "all",
        },
        {
          label: `中央空调用电/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "centerBase",
        },
        {
          label: `末端盘管用电/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "fanCoilUnit",
        },
        {
          label: `冷冻水泵用电/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "chilledWaterPump",
        },
        {
          label: `冷却水泵用电/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "coolingWaterPump",
        },
        {
          label: `冷却塔用电/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "coolingTower",
        },
        {
          label: `暖水泵用电/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "warmWaterPump",
        },
        {
          label: `燃烧风机用电/${
            this.activeTime.type == "MONTH" ? "kw·h" : "万kw·h"
          }`,
          prop: "combustionFan",
        },
      ];
    },
    getActiveTime(val) {
      this.$store.commit("SET_LOADING", true);
      this.activeTime = val;
      this.getTableHeade();
      this.excelTitle = `空调系统分析-${
        val.timeValue ? val.timeValue : "全部"
      }`;
      this.pubParams = {
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        assetType: "空调系统",
        type: this.activeTime.type,
        date: this.activeTime.timeValue,
      };
      this.getFourEC();
      this.getECData();
      this.getOverview(); //总览
      this.getECAnalysis(); //中央空调用电分析
      this.getRunTime("风机盘管"); //空调运行时间排行
      // this.getRunTime("分体式空调"); //空调运行时间排行
      this.getTable();
      if (val.type == "MONTH") {
        this.rightTitle = "每日用电排名";
      } else if (val.type == "YEAR") {
        this.rightTitle = "每月用电排名";
      } else {
        this.rightTitle = "每年用电排名";
      }
      setTimeout(() => {
        this.$store.commit("SET_LOADING", false);
      }, 1000);
    },
    getFourEC() {
      this.hoursCharts.xData = [];
      this.hoursCharts.unit = "";
      this.hoursCharts.dataArr = [
        { name: matchingECMode(this.hoursActive), data: [] },
      ];
      let params = Object.assign(this.pubParams, {
        energyType: this.hoursActive,
      });
      this.$store.dispatch("publicGetFourEC", { params }).then((res) => {
        this.hoursCharts.unit = res.unit;
        this.hoursCharts.xData = res.xData;
        this.hoursCharts.dataArr[0].data = res.yArr;
      });
    },
    async getECData() {
      this.electricityCharts.xData = [];
      this.electricityCharts.unit = [];
      this.electricityCharts.dataArr = [
        { name: matchingECMode(this.electricity), data: [] },
      ];
      let params = Object.assign(this.pubParams, {
        energyType: this.electricity,
      });
      this.$store.dispatch("publicGetECData", { params }).then((res) => {
        this.electricityCharts.unit = res.unit;
        this.electricityCharts.xData = res.xData;
        this.electricityCharts.dataArr[0].data = res.dataArr[0].data;
      });
    },
    async getOverview() {
      this.overviewData = [];
      // this.overviewChartData.dataArr = [
      //   { name: "分体式空调系统", value: null, unit: "kw·h" },
      //   { name: "中央空调系统", value: null, unit: "kw·h" },
      // ];
      let res = await api.ACOSUseGetOverview(this.pubParams);
      if (res && res.data.code == 200) {
        this.overviewData = Array.from(res.data.data).map((item) => ({
          title: item.name,
          num: handleNumDecimal(
            item.values.value > 10000
              ? item.values.value / 10000
              : item.values.value
          ),
          unit:
            item.values.value > 10000
              ? "万" + item.values.unit
              : item.values.unit,
          yoy: item.values.charts.find((v) => {
            return v.name == "同比";
          })?.value,
          mom: item.values.charts.find((v) => {
            return v.name == "环比";
          })?.value,
        }));
        // let arr = res.data.data.find((v) => {
        //   return v.name == "用电";
        // })?.values?.charts;
        // this.overviewChartData.dataArr.map((v) => {
        //   v.value = arr.find((item) => {
        //     return item.name == v.name;
        //   }).value;
        // });
      }
    },
    async getECAnalysis() {
      this.orderData.dataArr = [];
      let res = await api.ACOSUseGetECAnalysis(this.pubParams);
      if (res && res.data.code == 200) {
        this.orderData.dataArr = res.data.data.filter((v) => {
          return v.value;
        });
      }
    },
    async getRunTime(type) {
      let str = type == "风机盘管" ? "centralAir" : "splitAir";
      this[str].xData = [];
      this[str].yData = [];
      let params = Object.assign(this.pubParams, {
        size: 5,
        deviceType: type,
      });
      let res = await api.ACOSUseGetRunTime(params);
      if (res && res.data.code == 200) {
        res.data.data.map((v) => {
          this[str].xData.push(v.value);
          this[str].yData.push(v.name);
        });
      }
    },
    async getTable() {
      this.tableData = [];
      let params = Object.assign(this.pubParams, {
        centreType: "中央空调系统",
      });
      let res = await api.ACOSUseGetECTable(params);
      if (res && res.data.code == 200) {
        this.tableData = Array.from(res.data.data).map((item) => ({
          ...item,
          time:
            this.activeTime.type == "MONTH"
              ? dateFtt("dd日", new Date(item.ts))
              : this.activeTime.type == "YEAR"
              ? dateFtt("MM月", new Date(item.ts))
              : dateFtt("yyyy年", new Date(item.ts)),
        }));
        this.tableData.map((v) => {
          for (let key in v) {
            if (
              key == "all" ||
              key == "gasAll" ||
              key == "centerBase" ||
              key == "center" ||
              key == "coolingWaterPump" ||
              key == "chilledWaterPump" ||
              key == "coolingTower" ||
              key == "fanCoilUnit" ||
              key == "warmWaterPump" ||
              key == "combustionFan"
            ) {
              v[key] = handleNumDecimal(
                this.activeTime.type == "MONTH" ? v[key] : v[key] / 10000
              );
            }
          }
        });
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.airEnergyWrap {
  width: 100%;
  overflow: auto;
  .analysis {
    // height: 450px;
    height: 370px;
    width: $innerWidth;
    margin: 0 auto;
    @include setFlexBetween;
    .leftBox,
    .rightBox {
      width: $halfWidth;
    }
    .box1 {
      width: 49%;
      height: 100%;
    }
    .box3 {
      width: 100%;
      height: 100%;
    }
    .box2,
    .box4 {
      width: 50%;
      height: 100%;
    }
    .box1 {
      .topBox {
        width: 85%;
        margin: 0 auto 10px;
        // height: calc(30% - 10px);
      }
      .bottomBox {
        width: 85%;
        margin: 0 auto;
        height: 35%;
      }
    }
  }
  .chartsListBox {
    width: $innerWidth;
    height: 400px;
    margin: 12px auto;
    @include setFlexBetween;
    .leftCom,
    .rightCom {
      width: $halfWidth;
      height: 100%;
    }
  }
}
</style>
